<template>
  <main class="col-12 px1">
    <b-form @submit.stop.prevent="service_free_action">
      <fieldset>
        <div class="clearfix">
          <div id="ferieStart" class="clearfix mb1">
            <label label-for="telefon" class="h6 semi-bold darkblue gibson mt2 mb1 block">
              <span class="h5">Indtast telefonnummer</span>
            </label>
            <input v-if="!showMobile" class="px2 py1 col-7 mb2 px0 lightgrey-background darkblue border-none" v-model="form.telefon" placeholder="skal indeholde 8 cifre" id="telefon" type="text" />
            <input v-if="showMobile" class="p2 h4 regular col-12 lightgrey-background darkblue border-none" v-model="form.telefon" placeholder="skal indeholde 8 cifre" id="telefon" type="text" />
          </div>
          <div class="clearfix">
            <button type="submit" class="action-button p2 px3 h4 gibson regular" v-if="showMobile">
              <span>Gem</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
            <button type="submit" class="flex justify-center items-center action-button gibson h5 p2 regular" v-if="!showMobile">
              <span>Gem</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
          </div>
          <div class="clearfix mt3">
            <p class="h5 semi-bold line-height-4 darkblue gibson">
              Gemte telefonnumre
            </p>
          </div>
          <div class="col-12 px0 flex justify-start items-center mt2">
            <span class="h6 darkblue semi-bold inline-block col-4 px0">Telefon</span>
            <span class="h6 darkblue semi-bold inline-block col-4 px0">Dato</span>
          </div>
          <div class="col-12 px0 flex justify-start items-center py1" v-for="item in items" :key="item.id">
            <span class="h6 inline-block col-4 px0 h6">{{ item.phone }}</span>
            <span class="h6 inline-block col-4 px0 h6">{{ item.create }}</span>
            <button v-if="item.marketplace === '0'" class="not-rounded delete-button border-none" style="margin-left:auto;" type="button" @click="sletPhone(item.id)">
              <span>
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt-f"><path d='M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z' /></svg>
              </span>
            </button>
          </div>
        </div>
      </fieldset>
    </b-form>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
var todayDate = new Date().getDate()
export default {
  name: 'dineekstraphone',
  components: {
    loading,
    Simplert
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
  },
  data () {
    return {
      form: {
        telefon: ''
      },
      inactivesms: '0',
      // fields: [
      //   {
      //     label: 'Fra',
      //     key: 'holiday_from'
      //   },
      //   {
      //     label: 'Til',
      //     key: 'holiday_to'
      //   },
      //   { key: 'action', label: 'Slet' }
      // ],
      items: [],
      show: false,
      label: 'Loading...',
      overlay: 1,
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(new Date().setDate(todayDate - 1)),
        useCurrent: false,
        showClear: false,
        showClose: false
      }
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.telefon
            this.inactivesms = res.inactivesms
          },
          response => {
            alert('error')
          }
        )
    },
    sletPhone (item) {
      let confirmFn = function () {
        this.$parent.servicefree_remove(item)
      }
      let obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne telefon ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    servicefree_remove (item) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'telefon_remove', salesPerson: this.salesPerson, phoneid: item}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_free_action () {
      if (this.form.telefon.length !== 8) {
        return
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'addTelefon', salesPerson: this.salesPerson, telefon: this.form.telefon}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
              this.form.telefon = ''
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dineekstraphone.vue?6031ef79